import { create } from "zustand";

interface ExpandedStore {
    isCollapsed: boolean;
    setIsCollapsed: (isCollapsed: boolean) => void;
}

export const useExpandNavMenu = create<ExpandedStore>((set) => ({
    isCollapsed: false,
    setIsCollapsed: (isCollapsed) => set({ isCollapsed }),
}));
